import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { ReactComponent as HomeIcon } from '../../../assets/home-icon.svg';
import '../../navbar/newtrip-nav/NewTripNav.css'

const EditTripNav = () => {
  const { id } = useParams();  // Get the trip ID from the URL
  const [tripData, setTripData] = useState(null);

  // Fetch the trip data based on the trip ID
  useEffect(() => {
    const fetchTrip = async () => {
      try {
        const response = await axios.get(`/edit-trip/${id}`);
        setTripData(response.data);  
      } catch (error) {
        console.error("Error fetching trip data:", error);
      }
    };
    fetchTrip();
  }, [id]);

  return (
    <nav className="edit-trip-nav">
      <h1>Edit Trip</h1>
      
      {tripData ? (
        <h2>Editing: {tripData.TRIP_NAME}</h2>
      ) : (
        <p>Loading trip details...</p>
      )}

      <ul>        
      <li className="homenav-icon-header">
          <Link to="/" className="nav-link">
           <HomeIcon className = "homenav-icon"/>
            Home
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default EditTripNav;
